var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.7628 14.7115C15.1558 14.8425 15.5805 14.6301 15.7115 14.2372C15.8425 13.8442 15.6301 13.4195 15.2372 13.2885L14.7628 14.7115ZM12 13H11.25C11.25 13.3228 11.4566 13.6094 11.7628 13.7115L12 13ZM12.75 8.81855C12.75 8.40434 12.4142 8.06855 12 8.06855C11.5858 8.06855 11.25 8.40434 11.25 8.81855H12.75ZM15.2372 13.2885L12.2372 12.2885L11.7628 13.7115L14.7628 14.7115L15.2372 13.2885ZM12.75 13V8.81855H11.25V13H12.75ZM19.25 12C19.25 16.0041 16.0041 19.25 12 19.25V20.75C16.8325 20.75 20.75 16.8325 20.75 12H19.25ZM12 19.25C7.99594 19.25 4.75 16.0041 4.75 12H3.25C3.25 16.8325 7.16751 20.75 12 20.75V19.25ZM4.75 12C4.75 7.99594 7.99594 4.75 12 4.75V3.25C7.16751 3.25 3.25 7.16751 3.25 12H4.75ZM12 4.75C16.0041 4.75 19.25 7.99594 19.25 12H20.75C20.75 7.16751 16.8325 3.25 12 3.25V4.75Z",
    fill: "#6D757F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.a40fd8918a6dee10487a51578363655b.svg";
export { ForwardRef as ReactComponent };